import type { ExtraFieldName, TaskTypeOptions } from '@shared/model'
import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'

import { useListsStore } from '@shared/model'

import { useTasksKanbanStore } from '../store'

interface SelectConfigParserPayload {
  name: ExtraFieldName
}

interface SelectConfigParserReturn {
  options: ComputedRef<AppSelectOption[]>
  extraFields: ComputedRef<ExtraFieldName[]>
}

export const useSelectConfigParser = (payload: SelectConfigParserPayload): SelectConfigParserReturn => {
  const listsStore = useListsStore()
  const tasksKanbanStore = useTasksKanbanStore()

  const extraFields = computed(() => {
    const taskType = tasksKanbanStore.getTaskType
    const taskTypeOptions: TaskTypeOptions | null = !taskType
      ? null
      : (listsStore.getTaskTypes?.[taskType] || null)

    return taskTypeOptions?.extra_fields || []
  })

  const options = computed(() => {
    const valid = extraFields.value.includes(payload.name)
    if (!valid) return []

    return listsStore.getExtraFields?.[payload.name]?.values || []
  })

  return {
    extraFields,
    options,
  }
}
